import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

function TelecallerSuggestion() {
  const ID = Cookies.get("log_id");
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [socialworker, setSocialworker] = useState("");
  const [socialworkers, setSocialworkers] = useState([]);
  const [selectedUnemployed, setSelectedUnemployed] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const [Unemployed, setUnemployed] = useState([]);

  useEffect(() => {
    // Fetch candidates and social workers
    axios.get(`${url.path}/telecaller_suggestion/?id=${ID}`)
      .then((res) => {
        console.log("API Response:", res.data); // Debugging step

        if (res.data.status) {
          setCandidates(res.data.unemployed); // Set the candidates list
          setSocialworkers(Array.isArray(res.data.socialworkers) ? res.data.socialworkers : []); // Ensure it's an array
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: err.message
        });
      });
  }, [ID]);

  // Filter candidates based on searchTerm
  const filteredCandidates = candidates.filter((item) =>
    item.Candidate_Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredCandidates.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredCandidates.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected); // Change the page number
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0); // Reset to the first page when search term changes
  };

  const handleOpenModal = (cmp) => {
    setSelectedCandidate(cmp); // Open modal with the selected candidate
  };

  const handleCloseModal = () => {
    setSelectedCandidate(null); // Close the modal
  };
  const handleOModal = (cmp) => {
    setSelectedUnemployed(cmp);
  };

  
const handleCModal = () => {
setSelectedUnemployed(null);
};
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const handleSubmit = () => {
    const formdata = new FormData();
    formdata.append('id', ID);
    formdata.append('unemployed', selectedCandidate.id);
    formdata.append('status', "Submitted");
    console.log("Form Data to Submit:");
    console.log("ID:", ID);
    console.log("Unemployed ID:", selectedCandidate.id);
    console.log("Status:", "Submitted");

    axios.post(`${url.path}/telecaller_submit/`, formdata)
      .then((res) => {
        if (res.data.status) {
          Toast.fire({
            icon: 'success',
            title: 'Submitted'
          });
          setCandidates((prevState) =>
            prevState.filter((item) => item.id !== selectedCandidate.id) // Remove submitted candidate from the list
          );
        }
      })
      .catch((err) => {
        Toast.fire({
          icon: 'error',
          title: err
        });
      });

    handleCloseModal(); // Close the modal after submission
  };

  const handleModalClick = (e) => {
    e.stopPropagation(); // Prevent modal from closing when interacting with the form
  };

  function handleSocial(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append("id", ID);
    formdata.append("unemployed", selectedUnemployed.id);
    formdata.append("socialworker", socialworker);

    axios
      .post(`${url.path}/Assign_socialworker/`, formdata)
      .then((res) => {
        if (res.data.status) {
          Toast.fire({
            icon: "success",
            title: "Socialworker Assigned",
          });
          
          handleCModal();
          setCandidates((prevState) =>
            prevState.filter((item) => item.id !== selectedUnemployed.id) // Filter out the candidate
          );
          // Optionally, update the UI to reflect the assignment without re-fetching
          
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
  }


  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: '20px', position: 'relative', top: '10px' }}>Suggestion and counselling</h3>
      </center>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="responsive-table" id="unemptable">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Parent Details</th>
              <th>Type of Problem</th>
              <th>Problem Statement</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredCandidates.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center' }}>
                  No candidates found
                </td>
              </tr>
            ) : (
              currentItems.map((i, index) => (
                <tr key={i.id}>
                  <td>{index + 1}</td>
                  <td>{i.Candidate_Name}</td>
                  <td>{i.Email}</td>
                  <td>{i.Contact}</td>
                  <td>{i.Parent_Details}</td>
                  <td>{i.Typeof_problem}</td>
                  <td>{i.Problem_statement}</td>
                  <td>
                    <button type="button" style={{ width: '80px', backgroundColor: 'green', color: 'white', borderRadius: '5px' }}
                      onClick={() => handleOpenModal(i)} // Open modal for submission
                    >
                      Submit
                    </button>
                    <button type="button" style={{width:'100px',backgroundColor:'red',color:'white',borderRadius:'5px',marginLeft:'5px'}}  onClick={() => handleOModal(i)}
                                    >Further</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {filteredCandidates.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        )}
      </div>

      {selectedCandidate && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={handleModalClick}>
            <button className="close-button" onClick={handleCloseModal}>×</button>
            <h2>Verify Candidate</h2>
            <p>Are you sure to submit {selectedCandidate.Candidate_Name}?</p>
            <form>
              <center>
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{ width: '100px', backgroundColor: 'gainsboro', borderRadius: '5px' }}
                >
                  Submit
                </button>
              </center>
            </form>
          </div>
        </div>
      )}

{selectedUnemployed && (
        <div className="modal-overlay" onClick={handleCModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCModal}>
              &times;
            </button>
            <h2>Assign SocialWorker</h2>
            <p>Are you sure to assign {selectedUnemployed.Name}?</p>
            <form onSubmit={handleSocial}>
              <div className="form-group">
                <label>SocialWorker</label>
                <select value={socialworker} onChange={(e) => setSocialworker(e.target.value)}>
  <option>--Select--</option>
  {socialworkers && socialworkers.length > 0 ? (
    socialworkers.map((i) => (
      <option key={i.id} value={i.id}>
        {i.Employee_Name}
      </option>
    ))
  ) : (
    <option>No social workers available</option>
  )}
</select>
              </div>
              <center>
                <button type="submit" style={{ width: "100px", backgroundColor: "gainsboro", borderRadius: "5px" }}>
                  Assign
                </button>
              </center>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default TelecallerSuggestion;